import { UrlConstants } from "../url.constants";
export class ApiPropertyValuationValuationBlockFactorAdjustmentsConstants {
    static URL = UrlConstants.API_V2 + "PropertyValuationValuationBlockFactorAdjustments";
    static FUNCTION_DELETE_MULTIPLE_PROPERTY_VALUATION_BLOCK_FACTOR_ADJUSTMENTS = "DeleteMultipleValuationBlockFactorAdjustments";
    static FUNCTION_UPLOAD_VALUATION_BLOCK_FACTOR_ADJUSTMENTS = "UploadGeneralValuationBlockFactorAdjustments";
}
